import React, { useEffect } from 'react';
import { RouteFC } from 'util/routeTypes';

export const ScrollToTop: RouteFC = (({ children = null, location }) => {
  const pathname = location?.pathname;
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  // This is a fragment to a weird typing issue with ScrollToTop
  return (<>{children}</>);
});
